/**
 * Staff tasks (t1079) — to-dos that aren't support tickets, plus follow-ups
 * linked to one. Three states: complete, approve, send back and reopen are
 * plain guarded updates in the service, so there is no transition map.
 *
 * `pending_review` (t1216) is a task a staff member marked done that an
 * administrator (`tasks:review`) has not yet approved. Holders of that
 * permission, and the system, skip it and go straight to `done`. The order
 * matters: it is the enum order, so lists sort open, pending, done.
 */
export const TASK_STATUSES = ['open', 'pending_review', 'done'];
//# sourceMappingURL=task-states.js.map